import { useEffect } from "react";
import { useParams } from "react-router-dom";

import { webConfig } from "../../config.js";
import LoadingPage from "../components/common/LoadingPage";

/**
 * The ticket link from the ticket email (`/open/claim/<code>`) and the short
 * address on it (`/join`, `/join/<code>`). Reaching the site means the app
 * did not open the link (not installed, or the link was rewritten by email
 * security), so the attendee web app takes it: its ticket screen offers the
 * app and "Continue here" side by side, instead of a store redirect.
 */
export default function OpenTicket() {
  const { code } = useParams();

  useEffect(() => {
    const path = code ? `/claim/${encodeURIComponent(code)}` : "/claim";
    window.location.replace(`${webConfig.mobileWebUrl}${path}`);
  }, [code]);

  return <LoadingPage />;
}
